import React from "react";
import PropTypes from "prop-types";
import { FormNote } from "folksam-ui";
import Markdown from "components/Markdown";
const DescriptionField = ({ description }) =>
  description !== undefined ? (
    <FormNote>{description && <Markdown source={description} />}</FormNote>
  ) : (
    ""
  );

DescriptionField.propTypes = {
  id: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default DescriptionField;
